module.exports = __webpack_public_path__ + "static/media/Flygon_gaussian2.2c9bc6c9.png";